import * as React from 'react'
import { translateCountryName } from "@ui-seeker/utils"

import ShareOfSearchRetailerBlock from '../../RetailerBlock';


export default function retailerColumn() {
    return [{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	},{
        name: 'retailer', label: 'Retailer',
        options: {
			headerAlign: 'left',
            customBodyRowRenderLite: (value, { country, date, section, keyword, siteURL, pageURL }) => <ShareOfSearchRetailerBlock
				retailer={value}
				country={country}
				date={date}
				keyword={keyword}
                siteURL={siteURL}
                pageURL={pageURL}
			/>
        }
    }]
}